import { SessionHelper } from "app/helpers/sessionHelper";
import { api } from "../helpers/apiHelperV3";
import { urls } from "./urls";

//
const API_DEPOSIT = SessionHelper.isAsianSessionView()
  ? urls.cashier.API_DEPOSIT_ASIAN("neteller")
  : urls.cashier.API_DEPOSIT("neteller");

const API_WITHDRAW = SessionHelper.isAsianSessionView()
  ? urls.cashier.API_WITHDRAW_ASIAN("neteller")
  : urls.cashier.API_WITHDRAW("neteller");

const API_VERIFY = SessionHelper.isAsianSessionView()
  ? urls.cashier.API_VERIFY_ASIAN()
  : urls.cashier.API_VERIFY();

const API_REJECT = SessionHelper.isAsianSessionView()
  ? urls.cashier.API_REJECT_ASIAN()
  : urls.cashier.API_REJECT();

/**
 * Deposit funds to Neteller account
 */
export const depositFunds = (amount: string, email: string): any => {
  const url = API_DEPOSIT;
  const data = {
    amount: amount,
    email: email,
  };
  return api.post(url, data);
};

/**
 * Withdraw funds from Neteller account
 */
export const withdrawFunds = (amount: string, withdrawalEmail: string): any => {
  const url = API_WITHDRAW;
  const data = {
    amount: amount,
    email: withdrawalEmail,
  };
  return api
    .post(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Verifies with the API that the external deposit was a success
 */
export const verifiyDeposit = (id: string): any => {
  const url = `${API_VERIFY}/${id}`;
  return api
    .post(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Verifies with the API that the external deposit failed
 */
export const rejectDeposit = (id: string): any => {
  const url = `${API_REJECT}/${id}`;

  return api
    .delete(url)
    .then(resp => {
      console.log("delete resp: ", resp);
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
